import { useEffect, useState } from 'react'
import baseUse from './_baseUse'
import { getActiveScreens, getScreenContentTypes, getScreenZone } from 'services/screen-service'

export const useActiveScreens = () => {
  const screens = baseUse(getActiveScreens)
  return screens
}

export const useScreenContentTypes = screenId => {
  const [contentTypes, setContentTypes] = useState([])
  useEffect(() => {
    getScreenContentTypes(screenId).then(response => {
      if (response.data.data[0]) {
        const rawElements = response.data.data[0]
        const asArray = Object.entries(rawElements)
        const filtered = asArray.filter(([key, value]) => value !== null && typeof value === 'object')
        const elements = Object.fromEntries(filtered)
        for (const key in elements) {
          if (elements[key] !== undefined && elements[key].length === 0) {
            delete elements[key]
          }
        }

        setContentTypes(elements)
      }
    })
  }, [screenId])
  return contentTypes
}

export const useScreenZone = screenId => {
  const [zone, setZone] = useState(null)
  useEffect(() => {
    getScreenZone(screenId).then(response => {
      setZone(response.data.data[0]?.documentId)
    })
  }, [screenId])

  return zone
}
